import { useQuery } from 'react-query'
import { api } from '../../../api'
import { errorAlert } from '../../../../utils/alert'
import { localConfig } from '../../../../Configs/localConfig'

type Item = {
  cod: number
  cod_conta: number
  cod_usuario: number
  tipo: number
  create_time: string
  update_time: null
  delete_time: null
  create_user: null
  update_user: null
  delete_user: null
  usuario_nome: string
  usuario_status: number
  tipo_nome: string
}

interface UsuarioConsultor {
  itens: Item[]
}

export const useGetUsuarioConsultor = () => {
  const queryKey: ['usuario-tipo-consultor'] = [`usuario-tipo-consultor`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    UsuarioConsultor,
    Error
  >(
    queryKey,
    async () => {
      return api
        .get(`usuario-tipo-consultor?codConta=${localConfig()?.conta}`)
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de consultores!')
        })
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_usuarios_consultor: data,
    carregando_usuarios_consultor: isFetching,
    refetch_data_usuarios_consultor: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}
